import { ViewModel,View, ViewModelMessage } from "binder"
import { ElementDecorator, FormBuilderElement } from "../../element";
import { FormBuilderElementPropertyInvalidStatusChangedMessage } from "../../propertyValue";
import { CompactView } from "./compact-view";
import  { ErroredElementView } from "./erroredElement-view"

export class ErroredElementViewModel extends ElementDecorator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ErroredElementView();
    }
    public getTypeId(): string {
        return "VM-55D5DBFD-FBB6-410C-932F-FBBD69509232"
    }

    public set IsElementHasError(v: boolean) { this._IsElementHasError = v; } public get IsElementHasError(): boolean { return this._IsElementHasError;} private _IsElementHasError: boolean;
    
    getCompactViewForFormBuilderStructureViewDecorators(vm){
        return new CompactView();
    }
    handleMessage(msg:ViewModelMessage){
        if(msg instanceof FormBuilderElementPropertyInvalidStatusChangedMessage){
            let hasError = this.self.hasPropertyWithError();
            this.IsElementHasError = hasError;
            return null;
        }else{
            return super.handleMessage(msg);
        }
    }
}
